module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white-dfa0ab85ca50e08e893ff51b143cb607.png";